
import { useBlocker } from '@/shared/hooks/useBlocker'
import { LevelPlayOutOfHearts, LevelPlayOutOfTime } from '@/shared/level-play'
import { Blocker } from '@/shared/ui/Blocker'

import { useLevelContext, withLevel } from '../context'
import { DigitalProductJourneyLevelPlayChallenge } from './Challenge'
import { DigitalProductJourneyLevelFinish } from './Finish'

export const DigitalProductJourneyLevelPlay = withLevel(() => {
  const {
    level,
    currentScreen,
    onLevelRestart,
    config: { SCREENS }
  } = useLevelContext()

  const { checkBlockCondition } = useBlocker()
  const blocked = checkBlockCondition(level?._blockCondition)

  if (!blocked.unlocked && currentScreen == SCREENS.INITIAL_SCREEN)
    return <Blocker blockCondition={level?._blockCondition} />

  if (currentScreen == SCREENS.OUT_OF_TIME_SCREEN)
    return <LevelPlayOutOfTime onRestart={onLevelRestart} />
  if (currentScreen == SCREENS.OUT_OF_HEARTS_SCREEN)
    return <LevelPlayOutOfHearts onRestart={onLevelRestart} />
  if (currentScreen == SCREENS.FINISH_SCREEN)
    return <DigitalProductJourneyLevelFinish />
  else return <DigitalProductJourneyLevelPlayChallenge />
})
